// extracted by mini-css-extract-plugin
export default {"birthMonthControl":"ProfileUpdatePage_birthMonthControl_2Rtk2"};